<template>
  <v-layout row wrap>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.Objective') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <div>
                <img :src="objectiveType.instantMessages.imageUrl" class="imageIcon">
              </div>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ $t('message.bizgainOnboarding.summaryPage.instantMessagesObjective') }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <v-layout>
            <v-flex :class="{'xs10': isEditMessageApps && $vuetify.breakpoint.xsOnly, 'xs12': !isEditMessageApps || !$vuetify.breakpoint.xsOnly}">
              <span class="ml-1 label">
                {{ $t('message.bizgainOnboarding.summaryPage.receiveMessagesOn') }}:
              </span>
            </v-flex>
            <v-flex xs2 v-if="$vuetify.breakpoint.xsOnly && isEditMessageApps">
              <v-progress-circular
                v-if="isLoadingUpdateMessageApps && isEditMessageApps"
                size="24"
                color="info"
                indeterminate
              />
              <v-icon v-if="!isLoadingUpdateMessageApps" class="editIcon" @click="updateSelectedMessagingApps()">
                done
              </v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout v-if="!isEditMessageApps">
            <v-flex xs1>
              <v-icon class="greyIcon">
                message
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="ml-1 label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ getInstantMessagesAppsString }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="isEditMessageApps = true">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout v-if="isEditMessageApps">
            <v-flex
              xs12
              :class="{
                'pl-3':
                  $vuetify.breakpoint.mdAndUp
              }"
            >
              <v-card class="pa-2 mt-2">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="selectedAppsForInstantMessages"
                      color="primary"
                      class="black--text mt-0 mb-0"
                      :value="messengerDestination"
                      :ripple="false"
                    >
                      <template v-slot:label>
                        <v-img :src="fbMessengerIcon" width="25px" />
                        <span class="ml-1">Facebook Messenger</span>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="selectedAppsForInstantMessages"
                      color="primary"
                      class="black--text pa-0 mt-0 mb-0"
                      :value="instagramDirectDestination"
                      :ripple="false"
                    >
                      <template v-slot:label>
                        <v-img :src="instagramIcon" width="25px" />
                        <span class="ml-1">Instagram</span>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox
                      v-model="selectedAppsForInstantMessages"
                      color="primary"
                      class="black--text pa-0 mt-0 mb-0"
                      :value="whatsappDestination"
                      :ripple="false"
                    >
                      <template v-slot:label>
                        <v-img :src="whatsAppIcon" width="25px" />
                        <span class="ml-1">Whatsapp</span>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-btn
                      depressed
                      :loading="isLoadingUpdateMessageApps"
                      class="mx-0 next-btn-color next-btn-xs"
                      @click="updateSelectedMessagingApps()"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.ServicesPromoted') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout v-if="!isEditPromoteServices">
            <v-flex xs1>
              <v-icon class="greyIcon">
                home_repair_service
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ selectedServicesString }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="isEditPromoteServices = !isEditPromoteServices">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout v-if="isEditPromoteServices">
            <v-flex xs12>
              <v-card class="pa-2 mt-2">
                <v-layout row wrap class="promote-services">
                  <v-flex
                    xs12
                  >
                    <div>
                      <v-autocomplete
                        class="pt-0 mt-0"
                        v-model="selectedServices"
                        :items="allServices"
                        item-text="name"
                        item-value="id"
                        :placeholder="`Ex: ${allServices[0].name }`"
                        name="selectedServices"
                        v-validate="'required'"
                        @focus="clearErrorByField($event, 'selectedServices')"
                        :error="errors.has('selectedServices')"
                        :error-messages="
                          errors.first('selectedServices')
                            ? $t(
                              'message.bizgainOnboarding.selectedServiceWarning')
                            : null
                        "
                        small-chips
                        multiple
                        append-icon="keyboard_arrow_down"
                        :return-object="true"
                        :menu-props="{ maxHeight: 200 }"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            color="primary-transperant-variant"
                            text-color="black"
                            class="selected-services"
                            :selected="data.selected"
                          >
                            <span
                              class="selected-service-item"
                            >{{ data.item.name }}
                              <v-icon
                                small
                                class="
                              pr-1"
                                right
                                color="black"
                                @click="removeSelectedService(data.item)"
                              >
                                close
                              </v-icon>
                            </span>
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-flex>
                  <v-layout v-if="selectedServices.length > 1">
                    <alert
                      :icon-color="'primary'"
                      :icon-width="`${ !$vuetify.breakpoint.xsOnly ? 'xs1' : 'xs2' }`"
                      :outline="true"
                      :outline-color="'primary'"
                      :message="$t('message.bizgainOnboarding.promoteServiceAlert')"
                      :col-width="'xs12 sm10'"
                    />
                  </v-layout>
                  <v-flex xs12 md3>
                    <v-btn
                      depressed
                      :disabled="!isServiceSelected"
                      :loading="isLoadingUpdatePromoteServices"
                      class="mx-0 next-btn-color next-btn-xs"
                      @click="updateSelectedServices()"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
      v-if="false"
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.PromotionTag') }}
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                local_offer
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ offerTagline }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VLayout,
  VFlex,
  VIcon,
  VCheckbox,
  VImg,
  VCard,
  VBtn,
  VProgressCircular,
  VAutocomplete,
  VChip
} from 'vuetify/lib';
import Alert from 'Components/Alert/Alert';
import { Chat } from 'Mixins/chat';
import { instantMessageDestinationApps, objectiveType, bizgainOnboardingRoutes, bizgainConfig } from 'Features/bizgainOnboarding/constants';
import clearErrorByField from 'Mixins/clearErrorByField';
import { i18n } from '@/lang/';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [Chat, clearErrorByField],
  components: {
    VLayout,
    VFlex,
    VIcon,
    VCheckbox,
    VImg,
    VCard,
    VBtn,
    VProgressCircular,
    VAutocomplete,
    VChip,
    Alert
  },
  props: [
    'messagingApps',
    'offerTagline'
  ],
  data() {
    return {
      instantMessageDestinationApps,
      objectiveType,
      bizgainOnboardingRoutes,
      isEditMessageApps: false,
      selectedAppsForInstantMessages: [instantMessageDestinationApps.MESSENGER],
      messengerDestination: instantMessageDestinationApps.MESSENGER,
      instagramDirectDestination: instantMessageDestinationApps.INSTAGRAM_DIRECT,
      whatsappDestination: instantMessageDestinationApps.WHATSAPP,
      whatsAppIcon: bizgainConfig.whatsappIcon,
      instagramIcon: bizgainConfig.instagramSqIcon,
      fbMessengerIcon: bizgainConfig.fbMessengerIcon,
      newBusinessDetails: null,
      isLoadingUpdateMessageApps: false,
      isEditPromoteServices: false,
      isLoadingUpdatePromoteServices: false,
      allServices: [],
      selectedServices: []
    }
  },
  created() {
    this.getInstantMessagesAppsString;
    this.selectedAppsForInstantMessages = this.businessDetails.creativeDetail.instantMessagesApps;
    this.allServices = this.services.map(function(val, index){
      return { id: index, name: val };
    });
    if (this.promoteServices){
      this.promoteServices.forEach(promoteService => {
        let selectedService = this.allServices.find(service => service.name === promoteService);
        if (selectedService) {
          this.selectedServices.push(selectedService)
        }
      });
    }
  },
  methods: {
    ...mapActions(['patchBusinessDetails']),
    getInstantMessagingAppById(appId) {
      switch (appId) {
        case this.instantMessageDestinationApps['MESSENGER']:
          return i18n.tc('message.bizgainOnboarding.summaryPage.messenger');
        case this.instantMessageDestinationApps['INSTAGRAM_DIRECT']:
          return i18n.tc('message.bizgainOnboarding.summaryPage.instagram_direct');
        case this.instantMessageDestinationApps['WHATSAPP']:
          return i18n.tc('message.bizgainOnboarding.summaryPage.whatsapp');
        default:
          break;
      }
      return '';
    },
    async updateSelectedMessagingApps(){
      try {
        if(this.businessDetails){
          this.isLoadingUpdateMessageApps = true;
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          var selectedObjectiveType = null;
          this.newBusinessDetails.creativeDetail.instantMessagesApps = this.selectedAppsForInstantMessages;
          selectedObjectiveType = i18n.tc(objectiveType.instantMessages.conversionTitle);
          await this.updateUserProperties({ objectiveType: selectedObjectiveType });
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: this.newBusinessDetails
          };
          await this.patchBusinessDetails(payload);
          this.isEditMessageApps = false;
          this.isLoadingUpdateMessageApps = false;
        }
      }
      catch {
        this.isEditMessageApps = false;
        this.isLoadingUpdateMessageApps = false;
      }
    },
    goToSelectObjective(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.SelectObjective.name, params: { isAppFlow: true, summary: true } });
    },
    goToPromoteServices(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.PromoteServices.name, params: { isAppFlow: true } });
    },
    goToExtractOfferDetails(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.ExtractOfferDetails.name, params: { isAppFlow: true } });
    },
    removeSelectedService (service) {
      this.selectedServices.splice(this.selectedServices.indexOf(service), 1);
    },
    async updateSelectedServices() {
      if (this.selectedServices){
        try {
          if (this.businessDetails){
            this.isUpdatePromoteServices = true;
            this.isLoadingUpdatePromoteServices = true;
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            if (this.newBusinessDetails && this.newBusinessDetails.creativeDetail) {
              this.newBusinessDetails.creativeDetail.promoteServices = this.selectedServices.map(service=>service.name);
              let payload = {
                sessionId: this.businessDetails.sessionId,
                oldBusinessDetails: this.businessDetails,
                newBusinessDetails: this.newBusinessDetails
              };
              await this.patchBusinessDetails(payload);
              this.isLoadingUpdatePromoteServices = false;
              this.isEditPromoteServices = false;
              if(this.isError){
                this.isLoadingUpdatePromoteServices = false;
              }
            }
          }
        }
        catch {
          this.isLoadingUpdatePromoteServices = false;
          this.isEditPromoteServices = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'promoteServices', 'services']),
    getInstantMessagesAppsString() {
      return this.selectedAppsForInstantMessages.map(appId => {
        return this.getInstantMessagingAppById(appId)
      }).join(', ');
    },
    selectedServicesString(){
      return this.promoteServices.join(', ');
    },
    isServiceSelected() {
      return this.selectedServices.length > 0;
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-messages{
  min-height: 0px !important;
}

.greyIcon{
  color: #727891;
}
.editIcon{
  color: #13abb1;
}
.imageIcon{
  height: 28px;
  width: 25px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.detail-field{
  color: black;
  align-self: center;
}
@media only screen and (max-width: 600px) {
  .editIcon{
    color: #727891;
  }
}
.selected-services.v-chip {
    height: auto !important;
}

::v-deep .selected-services.v-chip .v-chip__content{
  height: auto !important;
}

::v-deep .selected-service-item {
  white-space: initial !important;
}
</style>

